// extracted by mini-css-extract-plugin
export var auto = "_4h-1";
export var spinner = "_4h-0";